export const MAX_CONTEXT_LENGTH = 140;

export const REASON_OPTIONS = [
  { key: "bug_fix", display_key: "Bug fix" },
  { key: "development", display_key: "Development" },
  { key: "account_management", display_key: "Account management" },
  { key: "research", display_key: "Research" },
  { key: "other", display_key: "Other" }
];

export const LABELS = {
  REASON_FOR_ACCESS: "Reason for access",
  CONTEXT: "Additional context"
};

export const PLACEHOLDERS = {
  SELECT_REASON: "Select a reason",
  ADD_CONTEXT: "Add additional context"
};

export const BUTTON_TEXT = {
  SUBMIT: "Submit",
  CLOSE: "Access Account"
};

export const SUCCESS_MESSAGES = {
  TITLE: "Account Access Granted",
  DESCRIPTION: "Your temporary access is now active and will remain valid for 24 hours."
};

export const ERROR_MESSAGES = {
  SUBMIT_FAILED: "Failed to submit access request. Please try again."
};
